<template>
  <v-container
    class="fill-height degradado"
    justify-center
    fluid
    grid-list-md
    color="primary"
  >
    <v-flex xs10 md6>
      <v-form ref="formLogin" @submit.prevent="login">
        <v-layout row>
          <v-flex xs12 md4 py-4 align-self-center>
            <img width="100%" src="../assets/digitrack.png" />
          </v-flex>
          <v-flex xs12 md8>
            <v-card elevation="8" class="pr-4">
              <v-card-text>
                <v-layout row pt-3 wrap>
                  <v-flex xs12 pt-5>
                    <v-text-field
                      :rules="[() => !!usuario || 'Campo requerido']"
                      color="primary"
                      light
                      hide-details="auto"
                      autofocus
                      label="Usuario"
                      outlined
                      placeholder="usuario@email.com"
                      v-model="usuario"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 pt-5>
                    <v-text-field
                      :rules="[() => !!contra || 'Campo requerido']"
                      light
                      hide-details="auto"
                      type="password"
                      label="Contraseña"
                      outlined
                      placeholder="Contraseña"
                      v-model="contra"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout pt-5>
                  <v-flex xs12 class="text-right">
                    <v-btn type="submit" color="primary" rounded>
                      Ingresar
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
    <v-footer app color="transparent">
      <v-spacer></v-spacer>
      <span class="mr-5 copy white--text font-weight-bold">
        COLUMBIA | &copy; 2021</span
      >
    </v-footer>
  </v-container>
</template>

<script>
import {login} from '../services/autenticacion';

export default {
  data: function() {
    return {
      usuario: '',
      contra: '',
    };
  },
  mounted: function() {
    localStorage.clear();
  },
  methods: {
    async login() {
      if (this.$refs.formLogin.validate()) {
        // const login = await this.apiPost('/api/login/authenticate');
        const res = await login(this.usuario, this.contra);
        if (res.data.result === 1) {
          const token = res.data.data.Table0[0].Token;
          const nombre = res.data.data.Table1[0].Nombre;
          const perfil = res.data.data.Table1[0].Perfil;
          const modulos = res.data.data.Table2.map((p) => p.ModuloID);
          const router = res.data.data.Table1[0].Router;
          localStorage.setItem('modulos', JSON.stringify(modulos));
          localStorage.setItem('jwt', token);
          localStorage.setItem('nombre', nombre);
          localStorage.setItem('perfil', perfil);
          localStorage.setItem('router', nombre);
          this.$router.push(router);
        } else {
          this.$root.mensajeError = res.data.message;
        }
      }
    },
  },
};
</script>

<style>
.degradado {
  background: linear-gradient(
    135deg,
    rgba(0, 80, 160, 1) 0%,
    rgba(0, 40, 85, 1) 100%
  );
}
.copy {
  line-height: 40px;
}
</style>
